<template>
  <div>
    <notifcation-bar :show-notification="isShown" @close="closeNotificationBar" />
    <top-nav :user="user" :user_manual_url="user_manual_url"/>
    <main-nav :user="user" :toggleMenu="emitToggleMenu" :isMenuOpen="isMenuOpen" />
  </div>
</template>

<script>
import TopNav from "../header/TopNav";
import MainNav from "../header/MainNav";
import NotifcationBar from "./NotifcationBar.vue";

export default {
  components: {
    TopNav,
    MainNav,
    NotifcationBar,
  },
  data() {
    return {
      isShown: false,
    };
  },
  props:{
    user:Object,
    toggleMenu:Function,
    isMenuOpen:Boolean,
    user_manual_url:String
  },
  methods: {
    closeNotificationBar() {
      this.isShown = false;
    },
    emitToggleMenu(){
      this.toggleMenu()
    }
  },
};
</script>
